<script setup lang="ts">
import type { PropType } from 'vue';
import type { GetArticlesQuery } from '@shared/gql/graphql';
import { createDietQaArticleLink } from '~/utils/createArticleLink';

defineProps({
  items: {
    type: Array as PropType<GetArticlesQuery['article']>,
    required: true,
  },
});
</script>

<template>
  <AtomsTitleCard heading="Q＆A 〜ダイエット中の疑問〜" color="cream">
    <div class="px-4">
      <div
        v-for="item in items"
        :key="item.permalink!"
        class="py-4 not-last:border-b border-gray-300 text-lg"
      >
        <NuxtLink
          class="block"
          :to="createDietQaArticleLink(item.permalink!)"
          >{{ item.title }}</NuxtLink
        >
      </div>
    </div>

    <div class="border-t border-gray-300 p-4 text-right">
      <NuxtLink to="/public/article/dietqa" class="underline font-bold"
        >もっと見る</NuxtLink
      >
    </div>
  </AtomsTitleCard>
</template>
